/*
 * Shows the note for the selected option value (snippets/kardima-option-note.liquid).
 * Spec: docs/pdp-spec.md § "Option note, 2026-09-30".
 */
(function () {
  function update() {
    var root = document.querySelector('product-info') || document;
    var box = root.querySelector('[data-kardima-option-note]');
    if (!box) return;
    var checked = root.querySelectorAll('variant-selects input:checked, variant-selects option:checked');
    var values = [];
    for (var i = 0; i < checked.length; i++) values.push(checked[i].value);
    var notes = box.querySelectorAll('[data-option-value]');
    for (var j = 0; j < notes.length; j++) {
      notes[j].hidden = values.indexOf(notes[j].getAttribute('data-option-value')) === -1;
    }
  }

  function init() {
    update();
    document.addEventListener('change', function () { setTimeout(update, 0); });
    var target = document.querySelector('product-info');
    if (target && window.MutationObserver) {
      new MutationObserver(update).observe(target, { childList: true, subtree: true });
    }
  }

  if (window.kardimaOptionNote) return;
  window.kardimaOptionNote = true;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
